import { PocDivider } from 'commons/components/components-wrapper/poc-divider.component';
import { PocLogo } from 'commons/components/components-wrapper/poc-logo.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { ProductIcon } from 'commons/icons/ProductIcon';
import { PRODUCT_DESCRIPTION, PRODUCT_NAME } from 'core/constants/constants';
import { ProductInfoStyled } from './product-info.style';

export const ProductInfoComponent = () => (
    <ProductInfoStyled>
        <PocLogo name="navify_light_green" size="mini" data-testid="header-logo-navify" />
        <div className="product_name">
            <PocTypography variant="title6">{PRODUCT_NAME}</PocTypography>
            <PocDivider direction="vertical" />
            <div>
                <ProductIcon />
                <PocTypography variant="body1">{PRODUCT_DESCRIPTION}</PocTypography>
            </div>
        </div>
    </ProductInfoStyled>
);
